import * as React from 'react';
import { Link } from '@cian/link-component';

export interface IProlongationPopupSingleContentProps {
  id: number;
  announcementUrl: string;
  address: string;
}

export const ProlongationPopupSingleContent: React.FC<IProlongationPopupSingleContentProps> = props => (
  <div>
    <span>Срок публикации объявления истек</span>
    <br />
    <Link href={props.announcementUrl} target="_blank">
      {props.address}
    </Link>
    <br />
    <span>
      Для восстановления объявления пройдите по{' '}
      <Link href={`https://cian.ru/razmestit-obyavlenie/?id=${props.id}`} target="_blank">
        ссылке
      </Link>
    </span>
  </div>
);
